import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Text, Icon } from '../../../../../components';

const SuggestedRewordingItemContainer = styled.div`
  display: inline-flex;
  align-items: flex-start;
  gap: 6px;
  padding: 8px;
  border-radius: 6px;
  width: auto;
  max-width: 100%;
  cursor: pointer;
  align-self: flex-start;
  border-bottom: 1px solid var(--border-muted);
  border-radius: 0px;
  flex-wrap: nowrap;
  &:hover {
    background: var(--wash-gray-hover);
    border-bottom: 1px solid transparent;
    border-radius: 8px;

    ${Text} {
      color: var(--black);
    }
  }
`;

const SuggestedRewordingItem = ({ question, onClick }) => (
  <SuggestedRewordingItemContainer onClick={onClick}>
    <Icon name='note' displaySize={20} color='var(--content-subtitle)' />
    <Text>{question}</Text>
  </SuggestedRewordingItemContainer>
);

SuggestedRewordingItem.propTypes = {
  question: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export { SuggestedRewordingItem };
